import { Component, OnInit } from '@angular/core'
import { BillingService } from '../../../../../api/services'
import { Router, ActivatedRoute } from '@angular/router'
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms'
import { DatePipe } from '@angular/common'
import { NgxSpinnerService } from 'ngx-spinner'
import { Customsort } from '../../../../directives/customsort'
import {
  DataPageOfBilling,
  Billing,
  BillingDto,
  UiPreferences,
} from '../../../../../api/models'
import { toArray, concat } from 'rxjs/operators'
import { SafeHtml, DomSanitizer } from '@angular/platform-browser'
import { validateAllFormFields } from '../../../../../formUtils'
import { MessageService, SortEvent } from 'primeng/api'
import { environment } from '../../../../../../environments/environment'
import { CareFinitySession } from '../../../../services/CareFinitySession'

@Component({
  selector: 'app-billing-list',
  templateUrl: './billing-list.component.html',
  styleUrls: ['./billing-list.component.css'],
})
export class BillingListComponent implements OnInit {
  Item = 'Billing'
  billingsummary: DataPageOfBilling
  diagsummary: DataPageOfBilling
  selectedPatient: Billing
  facilityList: Array<BillingDto>
  referringList: Array<BillingDto>
  physicianList: Array<BillingDto>
  rows: number
  billingform: UntypedFormGroup
  cols: any[]
  diagcols: any[]
  popupheader: string = ''
  radiobuttonhtml: SafeHtml
  displaypopup: boolean = false
  procedureValue: string = ''
  clinicalTemplate: Billing[]
  diagdisplaypopup: boolean = false
  diagcode: string = ''
  diagdesc: string = ''
  selecteddiag: string = ''
  showsearchdiag: boolean = false
  today: Date = new Date()
  facilityId: string = ''
  public activeIndex: number = 0
  InpatientLabelName: string = 'InPatient'
  OutpatientLabelName: string = 'OutPatient'
  OfficeLabelName: string = 'Office'

  popupheader_procedure: string = ''
  displaypopup_procedure: boolean = false
  procedure_displaypopup: boolean = false

  procCode: string = ''
  procDesc: string = ''
  proccols: any[]

  showsearch_proc: boolean = false

    showRecords: boolean = false;
    pageSize: number = 0;

    preferences: UiPreferences = {};
  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private bllservice: BillingService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private _spinnerService: NgxSpinnerService,
    private cstsort: Customsort,
    protected sanitizer: DomSanitizer,
    private customsort: Customsort,
  ) {}
    ngOnInit() {
      
        this.pageSize = CareFinitySession?.applicationSettings?.apiDataPageSize;
    this.cols = [
      { field: 'serviceDate', header: 'Service Date' },
      { field: 'procedureName', header: 'Procedure Description' },
      { field: 'procedureCode', header: 'Code' }, 
      { field: 'diag1', header: 'D1' },
      { field: 'diag2', header: 'D2' },
      { field: 'diag3', header: 'D3' },
      { field: 'diag4', header: 'D4' },
      { field: 'diag5', header: 'D5' },
      { field: 'diag6', header: 'D6' },
      { field: 'diag7', header: 'D7' },
      { field: 'diag8', header: 'D8' },
      { field: 'status', header: 'Status' },
    ]
    this.diagcols = [
      { field: 'diagnosisCode', header: 'Diagnosis Code' },
      { field: 'diagnosisName', header: 'Description' },
    ]

    this.proccols = [
      { field: 'procedureCode', header: 'Procedure Code' },
      { field: 'procedureName', header: 'Description' },
    ]

    this.billingform = this.fb.group({
      facility: new UntypedFormControl(null, [Validators.required]),
      reference: new UntypedFormControl(null),
      physician: new UntypedFormControl(null, [Validators.required]),
      status: new UntypedFormControl(''),
      procedureId: new UntypedFormControl(''),
      procedureName: new UntypedFormControl(null, [Validators.required]),
      diag1: new UntypedFormControl(''),
      diag2: new UntypedFormControl(''),
      diag3: new UntypedFormControl(''),
      diag4: new UntypedFormControl(''),
      diag5: new UntypedFormControl(''),
      diag6: new UntypedFormControl(''),
      diag7: new UntypedFormControl(''),
      diag8: new UntypedFormControl(''),
      mod1: new UntypedFormControl(''),
      mod2: new UntypedFormControl(''),
      mod3: new UntypedFormControl(''),
      mod4: new UntypedFormControl(''),
      lastApptDate: new UntypedFormControl(''),
      nextApptDate: new UntypedFormControl(''),
      serviceDate: new UntypedFormControl(this.today),
    })
        this.loadDD();

       

        const storedPreferences = localStorage.getItem('uiPreferences');
        if (storedPreferences) {
            this.preferences = JSON.parse(storedPreferences);

            this.Item = this.preferences?.charges || 'Billing';
        }
  }
  loadDD() {
    this.bllservice
      .billingGetallfacilityphysandreferrings({})
      .subscribe((Result) => {
        this.facilityList = Result.facilityList
        console.log(Result.facilityList)
        this.physicianList = Result.physicianList
        this.referringList = Result.referringList

        this.InpatientLabelName =
          Result?.inpatientLabelName == '' ||
          Result?.inpatientLabelName == 'undefined'
            ? 'In patient'
            : Result.inpatientLabelName
        this.OutpatientLabelName =
          Result?.outpatientLabelName == '' ||
          Result?.outpatientLabelName == 'undefined'
            ? 'Out patient'
            : Result.outpatientLabelName
        this.OfficeLabelName =
          Result?.officeLabelName == '' ||
          Result?.officeLabelName == 'undefined'
            ? 'Office'
            : Result.officeLabelName
        this.BillingList(1, 'Desc')
      })
  }

    BillingList(pageNumber: number, sortbydirection: string) {
        const patientId = sessionStorage.getItem('ptId');
        const emrPracticeId = localStorage.getItem('EmrPracticeId');

        this.bllservice
            .billingGetBillingList({ PatientId: patientId, emrpracticeId: emrPracticeId, pageNumber })
            .subscribe((result) => {
                console.log(result);
                this.billingsummary = result;

                const billingData = this.billingsummary?.data;
                if (billingData?.length) {
                    const { lastApptDate, nextApptDate } = billingData[0];
                    this.billingform.controls.lastApptDate.setValue(lastApptDate);
                    this.billingform.controls.nextApptDate.setValue(nextApptDate);
                }

                if (billingData?.length === 1 && this.isBillingSummaryEmpty(billingData[0])) {
                    this.billingsummary = null;
                } else {
                    // Remove the first user
                    billingData.splice(0, 1);
                }

                this.rows = this.billingsummary?.pageSize ?? 0; // Handle undefined pageSize gracefully
            });
    }





    // If summary itself is null/undefined
    isBillingSummaryEmpty(summary: any): boolean {
        if (!summary) return true;

        const fieldsToCheck = ['procedureCode', 'procedureName', 'status', 'serviceDate'];

        return fieldsToCheck.every(field => summary[field] == null || summary[field] === '');
    }


  setSelection(item) {
    if (item == '1') {
      this.displaypopup = true
      //  this.popupheader = 'Inpatient';
      this.popupheader = this.InpatientLabelName
    } else if (item == '2') {
      this.displaypopup = true
      // this.popupheader = 'Outpatient';
      this.popupheader = this.OutpatientLabelName
    } else if (item == '3') {
      this.displaypopup = true
      // this.popupheader = 'Office';
      this.popupheader = this.OfficeLabelName
    } else {
      this.displaypopup = false
    }
    if (this.displaypopup) {
      this.bllservice
        .billingLoadProcedures({
          PatientType: item,
        })
        .subscribe((result) => {
          this.clinicalTemplate = result.procedureList

          console.log('hhhhhhhhhhhhhhhhhhh')
          console.log(this.clinicalTemplate)

          const [codeSets] = this.clinicalTemplate

          console.log(codeSets)
        })
    }
  }
  setdiagnosis(item, type) {
    debugger
    this.diagdisplaypopup = true

    this.selecteddiag = 'diag' + item

    if (type == 'RD') {
      this.showsearchdiag = false
      this.diagsummary = null
      //  alert("Sv_BillingGetRecentDiagnosisList");
      this.recentdiagnosis()
      //  this.getrecentdiagnosis();
    } else {
      this.showsearchdiag = true
      this.diagsummary = null
      // alert("Sv_BillingGetDiagnosisList");
      // this.showsearchdiag = false;

      this.bllservice.billingLoadrecentdiagnosis({}).subscribe((result) => {
        this.diagsummary = result

        this.rows = this.diagsummary.pageSize

        if (this.diagsummary.totalRecords > 0) {
          this.showRecords = true
        } else {
          this.showRecords = false
        }
      })
    }
      this.popupheader = 'Diagnosis'+ item + ':' 
  }
  getrecentdiagnosis() {
    this.bllservice
      .billingLoadsearchdiagnosis({
        code: this.diagcode,
        name: this.diagdesc,
      })
      .subscribe((result) => {
        this.diagsummary = result
      })
  }

  emrpracticeId?: string | null
  PatientId?: string | null

  recentdiagnosis() {
    this.bllservice
      .billingLoadrecentdiagnosis({
        emrpracticeId: localStorage.getItem('PracticeId'),
        PatientId: sessionStorage.getItem('ptId'),
      })
      .subscribe((result) => {
        this.diagsummary = result

        this.rows = this.diagsummary.pageSize

        if (this.diagsummary.totalRecords > 0) {
          this.showRecords = true
        } else {
          this.showRecords = false
        }
      })
  }

  onRowSelect(event): void {
    debugger
    this.diagdisplaypopup = false
    this.billingform.get(this.selecteddiag).setValue(event.data.diagnosisCode)

    this.billingform.markAsDirty()
  }
  SelectProcedure(value, Name) {
    //this.billingform.get('procedureId').setValue(value);

    //this.billingform.get('procedureName').setValue(Name);

    this.billingform.get('procedureId').setValue(Name)

    this.billingform.get('procedureName').setValue(value)

    this.displaypopup = false
  }
  getbillingDetails(billingId) {
    debugger
    this.bllservice
      .billingGetDetail({
        BillingId: billingId,
      })
      .subscribe((result) => {
        debugger
        console.log(result)
        this.billingform.patchValue(result[0])

        // this.billingform.controls.status.setValue('');

        this.billingform.controls.facility.setValue({
          facilityID: result[0].facilityID,
        })
        this.billingform.controls.reference.setValue({
          referringId: result[0].referringId,
        })
        this.billingform.controls.physician.setValue({
          physicianId: result[0].physicianId,
        })

        this.activeIndex = 0
      })
    }


  //submitcharges() {
  //  //debugger
  //  validateAllFormFields(this.billingform)

  //  if (this.billingform.invalid) {
  //    return
  //  }

  //  console.log(this.billingform.value)

  //    const referringId = this.billingform.get('reference')?.value?.referringId ?? '';
  //    this.billingform.patchValue({ referringId });

  //    this.billingform.value.facilityID = this.billingform.get('facility').value.facilityID;





  //  this.billingform.value.physicianId =
  //    this.billingform.get('physician').value.physicianId
  //    this.billingform.value.lastApptDate = this.billingform.value.lastApptDate; //this.datePipe.transform(this.billingform.value.lastApptDate, environment.dateformat)
  //    this.billingform.value.nextApptDate = this.billingform.value.nextApptDate; //this.datePipe.transform(this.billingform.value.nextApptDate, environment.dateformat)
  //  this.billingform.value.serviceDate = this.datePipe.transform(this.billingform.value.serviceDate, environment.dateformat)
  //  this.bllservice
  //    .billingSubmitCharges({
  //      patientId: sessionStorage.getItem('ptId'),
  //      emrpracticeId: localStorage.getItem('PracticeId'),
  //      body: this.billingform.value,
  //    })
  //    .subscribe((result) => {
  //      if (result.status.toLowerCase().indexOf('ok') > -1) {
  //        this.messageService.add({
  //          key: 'alertToast',
  //          severity: 'success',
  //          summary: 'Confirmation',
  //          detail: result.message,
  //          life: 5000,
  //        })
  //        this.BillingList(1, 'Desc')
  //      }
  //      if (result.status.toLowerCase().indexOf('error') > -1) {
  //        this.messageService.add({
  //          key: 'alertToast',
  //          severity: 'error',
  //          summary: 'ERROR',
  //          detail: result.message,
  //          life: 5000,
  //        })
  //      }
  //    })
  //}



    submitcharges() {
        // Validate all form fields
        validateAllFormFields(this.billingform);

        if (this.billingform.invalid) {
            return;
        }

        // Prepare form values safely
        const formValue = this.billingform.value;

        const referringId = this.billingform.get('reference')?.value?.referringId || null;
        const facilityID = this.billingform.get('facility')?.value?.facilityID || null;
        const physicianId = this.billingform.get('physician')?.value?.physicianId || null;

        // Prepare payload for backend
        const payload = {
            ...formValue,
            referringId,                       // null if empty
            facilityID,
            physicianId,
            serviceDate: this.datePipe.transform(formValue.serviceDate, environment.dateformat),
            lastApptDate: formValue.lastApptDate,  // transform if needed
            nextApptDate: formValue.nextApptDate,  // transform if needed
        };

        // Call backend service
        this.bllservice
            .billingSubmitCharges({
                patientId: sessionStorage.getItem('ptId'),
                emrpracticeId: localStorage.getItem('PracticeId'),
                body: payload,
            })
            .subscribe((result) => {
                const status = result.status.toLowerCase();
                if (status.includes('ok')) {
                    this.messageService.add({
                        key: 'alertToast',
                        severity: 'success',
                        summary: 'Confirmation',
                        detail: result.message,
                        life: 5000,
                    });
                    this.BillingList(1, 'Desc');
                } else if (status.includes('error')) {
                    this.messageService.add({
                        key: 'alertToast',
                        severity: 'error',
                        summary: 'ERROR',
                        detail: result.message,
                        life: 5000,
                    });
                }
            });
    }





  setprocedure(item, type) {
    this.procedure_displaypopup = true

    if (type == 'R') {
      this.showsearch_proc = true
      this.diagsummary = null

      const status_other = this.billingform.get('status').value.status

      if (!status_other) {
        this.billingform.get('status').setValue('Other')

        // alert(this.billingform.get('status').value);
      }
      //  this.getprocedureSearch();
    }

    this.popupheader_procedure = 'Procedure Code:'
  }

  getprocedureSearch() {
    this.bllservice
      .billingSearchprocedures({
        code: this.procCode,
        name: this.procDesc,
      })
      .subscribe((result) => {
        this.diagsummary = result

        console.log(this.diagsummary)
      })
  }

  onRowSelectProc(event): void {
    debugger
    this.procedure_displaypopup = false
    this.billingform.get('procedureId').setValue(event.data.procedureCode)
    this.billingform.get('procedureName').setValue(event.data.procedureName)

    this.billingform.markAsDirty()
  }

  resetSearchProc() {
    this.procCode = null
    this.procDesc = null
    this.diagsummary = null
    // this.getprocedureSearch();
  }

  cancelDiagSummPopUp() {
    this.diagdisplaypopup = false
    this.diagsummary = null
  }

  clearSearch() {
    this.diagcode = ''
    this.diagdesc = ''
    this.diagsummary = null
  }

  customSort(event: SortEvent, num: number) {
    //alert(event);

    this.diagsummary.data = this.customsort.generalcustomSort(
      event,
      this.diagsummary.data,
    )
  }
}
